import { Handle, Position } from 'reactflow';
import { memo, useContext, useMemo } from 'react';
import { WorkflowContext } from 'providers/workflow-provider';
import Images from 'assets/Images';
import { getValueById } from 'utils';
import { useSelector } from 'react-redux';
import './style.scss';
import { HelpIcon } from 'components/generic';

const DecisionNode = ({ id, data }) => {
	const context = useContext(WorkflowContext);
	const { setNodeFlow, setNodeConfigureIndex, createObj, edges, dockerState, handleDeleteNode, handleComponentClick } = context;
	const { referenceData } = useSelector(state => ({ referenceData: state?.referenceData?.data }));

	const decisionTypesList = useMemo(() => getValueById(referenceData, 'rd_decisionTypes')?.value, [referenceData]);

	const edgeExists = useMemo(() => edges.some(el => el?.source === id), [edges]);

	const handleAdd = () => {
		if (dockerState !== 'view') {
			const index1 = createObj?.wf_nodes?.length;
			const index2 = createObj?.wf_nodes?.length + 1;
			const position1 = { x: data?.position?.x - 300, y: data?.position?.y + 200 };
			const position2 = { x: data?.position?.x + 300, y: data?.position?.y + 200 };
			const obj1 = { id: index1?.toString(), type: 'action', position: position1, data: { type: 'action', position: position1 } };
			const obj2 = { id: index2?.toString(), type: 'action', position: position2, data: { type: 'action', position: position2 } };
			setNodeFlow(obj1, index1, id, 'Yes');
			setNodeFlow(obj2, index2, id, 'No');
		}
	};

	const handleSidebar = () => {
		setNodeConfigureIndex(+id);
		handleComponentClick('decision');
	};

	return (
		<div className='header-node'>
			<div className='header-node__header space-between'>
				<div className='display-flex'>
					<h6>Decision</h6>
					<HelpIcon infoContent='Decision node is conditional node that goes for either Yes or No Action node' />
				</div>

				<div className='display-flex'>
					<img className='header-node__edit' src={Images['edit-blue']} alt='Edit' onClick={handleSidebar} height='15px' width='15px' />
					{!edgeExists && <img src={Images.deleteBlue} alt='Edit' onClick={() => handleDeleteNode(id)} height='15px' width='15px' />}
				</div>
			</div>
			<div className='header-node__description'>
				<Handle type='target' position={Position.Top} id={`top-${id}`} />
				<span>{!data?.action ? 'Configuring....' : `Outcome: ${getValueById(decisionTypesList, data?.action)?.value || '-'}`}</span>
			</div>
			<Handle type='source' position={Position.Bottom} id={`bottom-${id}`} />
			{!edgeExists && <img className='header-node__add' src={Images?.add} alt='Add' onClick={handleAdd} />}
		</div>
	);
};

export default memo(DecisionNode);
